export default {
  GlobalLanguageDictionary: {
    signout: 'Sign out',
    displaycolumns: 'Display columns',
    search: 'Search',
    reset: 'Reset',
    selectall: 'Select all',
    edit: 'Edit',
    adsearch: 'Advanced search',
    entrymanagement: 'Entry',
    onthejob: 'On the job',
    ontrial: 'On trial',
    toleave: 'To leave',
    leave: 'Leave',
    leaving: 'Leaving',
    onthejoball: 'On the job(all)',
    staffmanagement: 'Staff',
    cardprinting: 'Card printing',
    entryprinting: 'Entry printing',
    repairprinting: 'Repair printing',
    printinghistory: 'Printing record of work card history',
    printpreview: 'Print preview',
    noheadprint: 'No head print',
    printrecordexport: 'Print record export',
    bankcardmanagement: 'Bank card',
    employmentmanagement: 'Employment',
    tobecomemember: 'To become a full member',
    promotionmember: 'Promotion to become a full member',
    hasmemember: 'He has become a full-time employee',
    regularmemember: 'Promoted to regular',
    contractmanagement: 'Contract',
    tobesigned: 'To be signed',
    agreementtobesigned: 'Agreement to be signed',
    torenew: 'To renew',
    signed: 'Signed',
    agreementsigned: 'The agreement has been signed',
    changemanagement: 'Change',
    leaveoffice: 'Leave office',
    applyleavelist: 'Application for resignation list',
    inprocess: 'In process',
    completed: 'Completed',
    datamanagement: 'Data',
    locationinformation: 'Location',
    company: 'Company',
    organization: 'Organization',
    post: 'Post',
    positionname: 'Position',
    performanceappraisal: 'Performance appraisal',
    performanceappraisaldetails: 'Performance appraisal details',
    jobdescription: 'Job description',
    jobdescriptiondetails: 'Job description details',
    jobdescriptionduty: 'Job description duty',
    positionlevel: 'Position Level',
    dictionaries: 'Dictionaries',
    accesscontrol: 'Access',
    paycard: 'Credit card',
    permission: 'Permission',
    pleaseenter: 'Please enter',
    pleasechoose: 'Please choose',
    startdate: 'Start date',
    enddate: 'End date',
    to: 'To',
    filename: 'File name',
    sheetname: 'Sheet name',
    exportdatatype: 'Export data type',
    exportcolumns: 'Export columns',
    allcurrent: 'All data of current filter condition',
    selectdata: 'Select data',
    selectdatause: 'Select data (use after checking data)',
    currentpagedata: 'Current page data',
    alldata: 'All data',
    printing: 'Printing',
    seldataop: 'Please select the data to operate',
    nodata: 'No data',
    incorrectinformation: 'Incorrect information',
    and: 'And',
    or: 'Or',
    equal: 'Equal',
    notEqual: 'Not equal',
    less: 'Less',
    lessorequal: 'Less or equal',
    greater: 'Greater',
    greaterorequal: 'Greater or equal',
    startswith: 'Start swith',
    endswith: 'Ends with',
    contains: 'Contains',
    notContains: 'Not contains',
    in: 'In',
    notin: 'Not In',
    suretodelete: 'Are you sure to delete?',
    openoaaccount: 'Open OA account',
    back: 'back',
    backhome: 'Back home',
    keywordsfilter: 'Enter to filter',
    selectbatchedit: 'Select batch edit field',
    viewhistoryprint: 'View history print',
    sumbit: 'Sumbit',
    confirm: 'Confirm',
    details: 'Details',
    withdrawalofresignation: 'Withdrawal of resignation',
    makedeparture: 'Make up for self departure',
    inputjobnumber: 'Input job number, multiple job numbers are separated by,',
    duty: 'Duty',
    addgrouping: 'Add group',
    addconditions: 'Add condition',
    add: 'Add',
    undo: 'Undo',
    save: 'Save',
    delete: 'Delete',
    enter: 'Enter',
    cancel: 'Cancel',
    export: 'Export',
    batchinduction: 'Batch induction',
    inservice: 'In service',
    audit: 'audit',
    batchaudit: 'Batch audit',
    downloadtemplate: 'Download template',
    import: 'Import',
    batchchange: 'Batch change',
    alreadychanged: 'Already changed',
    batchsubmission: 'Batch submission',
    batchconfirmation: 'Batch confirmation',
    jobnumberimport: 'Job number import',
    importemployeephone: 'Import employee phone',
    workno: 'Job number',
    entrydate: 'Entry date',
    personname: 'Person name',
    idcard: 'ID card',
    employmenttype: 'Employment type',
    starttime: 'Start time',
    laborcontractsigner: 'Labor contract signer',
    encode: 'Encode',
    designation: 'Name',
    legalpersonnumber: 'Legal person number',
    legalpersonname: 'Legal person name',
    superiorno: 'Superior no',
    organizationno: 'Organization no',
    organizationname: 'Organization name',
    positionnumber: 'Position number',
    rankname: 'Rank name',
    dictionarytype: 'Dictionary type',
    dictionarynumber: 'Dictionary number',
    dictionaryname: 'Dictionary name',
    postnumber: 'Post number',
    postname: 'Post name',
    secondaryagent: 'Secondary agent',
    thirdlevelagency: 'ThirdLevel agency',
    leavedate: 'Leave date',
    sincereissuedate: 'Since reissue date',
    certificatenumber: 'Certificate number',
    effectivedate: 'Effective date',
    check: 'Check',
    operation: 'Operation',
    employeeinformationdetails: 'Employee information details',
    employmentinformation: 'Employment information',
    resignationinformation: 'Resignation information',
    personalinformation: 'Personal information',
    contactinformation: 'Contact information',
    ducationalexperience: 'Ducational experience',
    workexperience: 'Work experience',
    identityinformation: 'Identity information',
    becomeinformation: 'Employment information',
    salaryinformation: 'Salary information',
    employeejobnumber: 'Employee job number',
    firstworkingdate: 'First working date',
    agedate: 'Age date',
    employmentstatus: 'Employment status',
    typesofemployment: 'Types of employment',
    employeecharacteristics: 'Employee characteristics',
    sourceofemployeeresume: 'Source of employee resume',
    sourcenote: 'Source note',
    generalcontractor: 'General contractor',
    occupationtype: 'Occupation type',
    salarycalculationemployeetype: 'Salary calculation employee type',
    lengthofservice: 'Length of service (years)',
    companyemail: 'Company email',
    typesofsocialsecurity: 'Types of social security',
    agreementdeduction: 'Agreement deduction',
    iccard: 'IC card',
    actualconfirmationdate: 'Confirmation date',
    trialenddate: 'Trial end date',
    probationcontractsalary: 'Basic salary during probation period',
    probationpostsalary: 'Post salary in probation period',
    probationbonussalary: 'Trial bonus',
    becomecontractsalary: 'Basic salary after becoming a regular',
    becomepostsalary: 'Post salary after becoming a regular',
    becomebonussalary: 'Bonus after becoming a full member',
    leavereasontype: 'Reasons for leaving Type',
    leavereason: 'Reasons for leaving',
    personneldeduction: 'Amount of personnel deduction',
    isbackshoekey: 'Return the shoe cabinet key',
    isbackphonetag: 'Return the mobile phone label',
    isbackworkclothesshoes: 'Return work clothes and shoes',
    deductionworkclothesshoesmoney: 'Deduction for work clothes and shoes',
    isbackdormitorykey: 'Do you want to return the dormitory key',
    deductiondormitorykeymoney: 'Deduction of dormitory key amount',
    isbackbrand: 'Return the brand',
    deductionbrandmoney: 'Deduction amount of brand',
    postregistrationdeduction: 'Make up deduction for self departure',
    essentialinformation: 'Essential information',
    nationality: 'Nationality',
    cardtype: 'Document type',
    idcardnum: 'ID number',
    validbegindate: 'Effective start date',
    validenddate: 'Effective end date',
    signagency: 'SignAgency',
    name: 'Name',
    birth: 'Date of birth',
    age: 'Age',
    birthaddress: 'Native place',
    nodeType: 'Account type',
    englishname: 'English name',
    maritalstatus: 'Marital status',
    sex: 'Sex',
    politicsstatus: 'Political outlook',
    ethnic: 'Nation',
    isdisabled: 'People with disabilities',
    equipmentphoto: 'Employee portrait',
    contactmode: 'Contact mode',
    addressinformation: 'Address information',
    contactpeopleinformation: 'Contact information',
    countrycode: 'Country/region/code',
    phone: 'Phone number',
    email: 'Personal email',
    province: 'Province',
    currentaddress: 'Detailed address',
    zipcode: 'Postcode',
    emergencyperson: 'Contact name',
    emergencyrelation: 'Relationship with employees',
    emergencycontact: 'Contact phone number',
    isemergency: 'Is it an emergency contact',
    graduateschool: 'University one is graduated from',
    professional: 'Major',
    educationnature: 'Educational background',
    education: 'Education',
    educationstartdate: 'Start date of Education',
    educationenddate: 'End date of Education',
    certificateno: 'Diploma code',
    academicdegreeno: 'Degree certificate code',
    ishighesteducation: 'Is it the highest education',
    certificateimage: 'Picture of graduation certificate',
    academicdegreeimage: 'Picture of degree certificate',
    workunit: 'Name of work unit',
    workpost: 'Title of position',
    worktimefrom: 'Work start date',
    worktimeto: 'Work end date',
    reasonleaving: 'Reasons for leaving',
    provename: 'Witness',
    provephone: "Reference's mobile phone number",
    upload: 'Upload',
    clickupload: 'Click upload',
    filemanagement: 'File management',
    file: 'File',
    abnormalState: 'Abnormal state',
    version: 'Version',
    newfeatures: 'New features',
    bug: 'BUG',
    optimization: 'Optimization',
    submittedon: 'Submitted on',
    articles: 'Articles',
    title: 'Title',
    type: 'Type',
    exitnail: 'Exit nail',
    synchronizationcardnumber: 'Synchronization card number',

    //新
    dashboard: 'dashboard',
    systemlogin: 'Login System',
    login: 'Login',
    rememberpwd: 'Remember Password',
    entername:'Please Enter LoginName',
    enterpwd:'Please Enter Password',
    loginsuccess:'Login Successful',
    loginout:'Sign Out',
    companyname: 'Company Name',
    username:'User Name',
    password: 'Password',
    prompt: 'Prompt',
    changepwd: 'Change Password',
    oldpwd: 'Original password',
    newpwd: 'New password',
    confirmpwd: 'Confirm password',
    enteroldpwd: 'Please enter the original password!',
    oldpwdwrong: 'Original password error!',
    enternewpwd: 'Please enter a new password!',
    regnewpwd: 'Enter a password with a length of 8-30 characters, including English case, numbers and special symbols!',
    enterfirmpwd: 'Please confirm the password!',
    enterconpwd: 'The passwords entered twice are different!',
    isolateselect: 'Data isolation selection',
    // 系统名称
    HRMS: 'Manufacturing  Employee Details',
    Attendance: 'Manufacturing Attendance System',
    HRMS_India: 'Indian manufacturing personnel system',
    MainSystem: '主系统',
    HrRecruit: '制造招聘系统',
    FatoryAccess: '工厂门禁系统',
    Attendances: '制造考勤机系统',
    Course: '制造培训系统',
    CarAppoint: '车辆预约系统',
    paperless: '制造无纸化系统',
    Paperless: '制造无纸化系统',
    EMS: '设备管理系统',
    SZHRMS: '深圳人事系统',
    CourseQC: '深圳培训系统',
    SalaryManagement: '制造薪酬系统',
    AuditAttendance: '制造闻泰考勤系统(稽核)',
    FactoryGuard: '制造工厂门禁系统',
    NewProperty: '制造物业管理系统',
    ComplianceAttendance: '合规考勤',
    Salary: '薪酬系统(工资条)',
    EarlyWarn: '预警系统',
    AttendanceIndia: '制造考勤系统（印度版）',
    HRMSIT: 'IT人事系统',
    FactoryGuardTwo: '制造整机门禁系统',
    DLCost: '制造成本预算&DL费用管理',
  }
}
